import { Env } from "../../../index";
import { AddOnsCatalog } from "../../classes/add_on/AddOn";
import a001AddOnStage from "./stage/a001";
import a002AddOnStage from "./stage/a002";
import a003AddOnStage from "./stage/a003";
import a004AddOnStage from "./stage/a004";
import a005AddOnStage from "./stage/a005";
import a009AddOnStage from "./stage/a009";
import a010AddOnStage from "./stage/a010";
import a011AddOnStage from "./stage/a011";
import a012AddOnStage from "./stage/a012";
import a013AddOnStage from "./stage/a013";
import a001AddOnProd from "./prod/a001";
import a002AddOnProd from "./prod/a002";
import a003AddOnProd from "./prod/a003";
import a004AddOnProd from "./prod/a004";
import a009AddOnProd from "./prod/a009";
import a013AddOnProd from "./prod/a013";

const stageAddOns = new AddOnsCatalog({
	addOns: [
		a001AddOnStage,
		a002AddOnStage,
		a003AddOnStage,
		a004AddOnStage,
		a005AddOnStage,
		a009AddOnStage,
		a010AddOnStage,
		a011AddOnStage,
		a012AddOnStage,
		a013AddOnStage,
	],
});

const prodAddOns = new AddOnsCatalog({
	addOns: [
		a001AddOnProd,
		a002AddOnProd,
		a003AddOnProd,
		a004AddOnProd,
		a009AddOnProd,
		a013AddOnProd,
	],
});

const addOns = (env: Env) => {
	switch (env) {
		case Env.STAGE:
			return stageAddOns;
		default:
			return prodAddOns;
	}
};

export { addOns };
